/* eslint-disable global-require */
module.exports = ['auctioneers.sale.lots.top5.m1'];
